import { render, staticRenderFns } from "./ChapterFilter.vue?vue&type=template&id=4666517c&scoped=true"
import script from "./ChapterFilter.vue?vue&type=script&lang=js"
export * from "./ChapterFilter.vue?vue&type=script&lang=js"
import style0 from "./ChapterFilter.vue?vue&type=style&index=0&id=4666517c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4666517c",
  null
  
)

export default component.exports